<template>
  <div class="edit-style-select-box">
    <span class="common-label">{{ labelText }}</span>
    <div class="common-select">
      <select
        v-if="isFontFamilyName"
        :value="selectedFontFamilyName"
        :disabled="disabled"
        @input="updateFontFamily($event.target.value)">
        <option v-for="option in options" :key="option.text" :value="option.text">
          {{ option.text }}
        </option>
      </select>
      <select
        v-else
        :value="value"
        :disabled="disabled"
        @input="updateValue($event.target.value)">
        <option v-for="option in options" :key="option.text" :value="option.value">
          {{ option.text }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
import EditStyleSelectBase from '@/components/Content/Palette/CommonLayouts/Base/EditStyleSelectBase'

export default {
  props: [
    'target',
    'value',
    'disabled'
  ],
  mixins: [
    EditStyleSelectBase,
  ],
  computed: {
    updateTargetAttrs () {
      return this.target === 'width' || this.target === 'data-display-sns'
    },
    isFontFamilyName () {
      return this.target === 'font-family-name'
    },
  },
  data () {
    return {
      labelText: null,
      options: [],
      selectedFontFamilyName: null, // フォント用
    }
  },
  methods: {
    initSelectedFontFamilyName () {
      if (this.isFontFamilyName) {
        this.selectedFontFamilyName = this.value ? this.value : '---'
      }
    },
    updateValue (value) {
      if (this.updateTargetAttrs) {
        this.updateAttrs(value)
      } else {
        this.updateStyles(value)
      }
    },
    updateFontFamily (value) {
      let styles

      if (value === '---') {
        // 未選択の場合、nullを設定する
        styles = [{ prop: 'font-family-name', value: null }, { prop: 'font-family', value: null }]
      } else {
        const fontFamily = this.options.find(option => option.text === value)
        styles = [{ prop: 'font-family-name', value: value }, { prop: 'font-family', value: fontFamily.value }]
      }
      this.$emit('updateStyles', styles)
    },
    updateAttrs (value) {
      // value が空欄の場合、nullを設定する
      const attrs = value ? [{ prop: this.target, value: value }] : [{ prop: this.target, value: null }]
      this.$emit('updateAttrs', attrs)
    },
    updateStyles (value) {
      // value が空欄の場合、nullを設定する
      const styles = value ? [{ prop: this.target, value: value }] : [{ prop: this.target, value: null }]
      this.$emit('updateStyles', styles)
    },
  },
  beforeMount () {
    this.options = this.initOptions(this.target)
    this.initSelectedFontFamilyName()
  },
  mounted () {
    this.labelText = this.initLabelText(this.target)
  },
  watch: {
    value () {
      this.initSelectedFontFamilyName()
    },
  }
}
</script>

<style lang="scss" scoped>
.edit-style-select-box {
  position: relative;
  label {
    font-size: 12px;
    color: #fff;
    position: absolute;
    top: -30px;
    z-index: 10;
    background: rgba(72, 72, 72, 0.9);
    padding: 1px 8px;
    border-radius: 5px;
    &::before {
      width: 0;
      height: 0;
      content: '';
      border-style: solid;
      border-width: 8px 5px 0 5px;
      border-color: rgba(72, 72, 72, 0.9) transparent transparent transparent;
      position: absolute;
      top: 100%;
      left: 50%;
      z-index: 10;
      transform: translateX(-50%);
    }
  }
}

:disabled {
  background-color: rgb(190, 189, 189);
}
</style>
